module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: [_vm.sizeClass, _vm.variantClass, {
      loading: _vm.loading
    }],
    attrs: {
      "disabled": _vm.disabled || _vm.loading,
      "type": _vm.type
    },
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('span', {
    staticClass: "button-content-container",
    class: {
      loading: _vm.loading
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInFast",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "button-loader"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/icons/preloadder.gif"),
      "alt": "Loading..."
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c58d04b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseButton.vue
// module id = 114
// module chunks = 0